import { render, staticRenderFns } from "./PostCategories.vue?vue&type=template&id=6228a3ea&scoped=true&"
import script from "./PostCategories.vue?vue&type=script&lang=js&"
export * from "./PostCategories.vue?vue&type=script&lang=js&"
import style0 from "./PostCategories.vue?vue&type=style&index=0&id=6228a3ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228a3ea",
  null
  
)

export default component.exports